export class iTaojinAppUtil {
    static keys = {
        "android": 'iTaojinAndroidInterface',
        "ios": 'iTaojinIosInterface',
        "harmonyos": 'iTaojinHarmonyInterface',
    }

    static getPhoneOS() {
        var u = navigator.userAgent,
            isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
            isHarmonyOS = u.indexOf('ArkWeb') > -1 || u.indexOf('HarmonyOS') > -1; 
        
        if (isAndroid) {
            return 'android';
        }
        if (isHarmonyOS) {
            return 'harmonyos'
        }
        if(/(iPhone|iPad|iPod|iOS)/i.test(u)) { 
            return 'ios';
        }
    }
    static getAppInterface() {
        const phoneOS = this.getPhoneOS();
        const key = this.keys[phoneOS];

        if (phoneOS == 'android') {
            return window[key];
        }
        if (phoneOS == 'harmonyos') {
            return window[key];
        }
        if (phoneOS == 'ios') {
            return window["webkit"].messageHandlers[key];
        }
    }
/**
* @param funName 需要调用的原生方法名称
* @param funParams 需传递的参数
*/
    static callNativeFun(funName, funParams) {
        try {
            let native = this.getAppInterface();
            const phoneOS = this.getPhoneOS();
            if (!native || !phoneOS) return {result: false, data: null}
            let data = null;
            if (phoneOS == 'android') {
                if (funParams) {
                    data = native[funName](JSON.stringify(funParams));
                }else {
                    data = native[funName]()
                }
            }
            if (phoneOS == 'harmonyos') {
                if (funParams) {
                    data = native[funName](JSON.stringify(funParams));
                }else {
                    data = native[funName]()
                }
            }
            if (phoneOS == 'ios') {
                if (funParams) {
                    native.postMessage({
                      methods: funName,
                      params: funParams
                    })
                }else {
                    native.postMessage({ methods: funName });
                }
            }
            return {
                result: true,
                data: data
            }
        } catch (e) { 
            return {
                result: false,
                data: null
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/utils/iTaojinAppUtil.js